import { API_BACKOFFICE_ASSETS } from '../../services/api/apiConst';
import axios from 'axios';
import dayjs from 'dayjs';
import { API_USERS_TASKS_RESPONSES } from '../../services/api/apiConstV2';
import { PARAMS } from '../../const';
import { removeDiacritics } from '../../utils/stringUtils';
import * as assetsService from '../../services/assets/assetsService';
import { setUploadContentStatus } from '../../actions/bookActions';

export async function uploadFreeAssignmentResponse(filesToUpload, context, setUploadContentTaskStatus) {
  const { userId, customerId, taskId, assetType, classroomId } = context;
  const assetsMetaData = filesToUpload.map(file => {
    return {
      fileName: removeDiacritics(file.name || file.fileName),
      customerId,
      assetType,
      classroomId
    };
  });

  const uploadAssetPromises = uploadMultipleAssets(filesToUpload, assetsMetaData, setUploadContentTaskStatus);
  return Promise.all(uploadAssetPromises).then(values => {
    const payload = {
      response: {
        files: values.map(value =>
          API_BACKOFFICE_ASSETS.replace(PARAMS.ASSET, value.uuid).replace(PARAMS.CUSTOMER, customerId)
        )
      }
    };

    const url = `${API_USERS_TASKS_RESPONSES}`.replace(PARAMS.USER, userId).replace(PARAMS.TASK, taskId);
    setUploadContentTaskStatus({ percentCompleted: 100, isUploading: false });
    return axios.put(url, payload);
  });
}

const uploadMultipleAssets = (filesToUpload, assetsMetaData, handleUploadContentStatus) => {
  return filesToUpload.map((file, index) => {
    return assetsService.uploadAsset(file, assetsMetaData[index], { handleUploadContentStatus });
  });
};

export async function uploadCommentTaskResponse(message, userId, username, customerId, taskId) {
  let payload = {
    response: {
      commentMessageText: message
    }
  };
  let url = `${API_USERS_TASKS_RESPONSES}`.replace(PARAMS.USER, userId).replace(PARAMS.TASK, taskId);
  return axios.put(url, payload);
}

export async function uploadFreeAssignmentCommentAndFilesResponse(
  commentMessageText,
  filesToUpload,
  context,
  setUploadContentTaskStatus
) {
  const { userId, customerId, taskId, assetType, classroomId } = context;

  let filesPayload = {};
  let responsePayload = {};

  // Files
  if (filesToUpload && filesToUpload.length > 0) {
    const assetsMetaData = filesToUpload.map(file => {
      return {
        fileName: removeDiacritics(file.name || file.fileName),
        customerId,
        assetType,
        classroomId
      };
    });
    const uploadAssetPromises = uploadMultipleAssets(filesToUpload, assetsMetaData, setUploadContentTaskStatus);
    const uploadedFiles = await Promise.all(uploadAssetPromises);
    filesPayload = {
      files: uploadedFiles.map(value =>
        API_BACKOFFICE_ASSETS.replace(PARAMS.ASSET, value.uuid).replace(PARAMS.CUSTOMER, customerId)
      )
    };
    responsePayload = { ...filesPayload };
  }

  // CommentMessageText
  if (commentMessageText) {
    responsePayload.commentMessageText = commentMessageText;
  }

  const payload = { response: responsePayload };

  const url = `${API_USERS_TASKS_RESPONSES}`.replace(PARAMS.USER, userId).replace(PARAMS.TASK, taskId);
  setUploadContentTaskStatus({ percentCompleted: 100, isUploading: false });

  return axios.put(url, payload);
}

export async function uploadFreeAssignmentEvaluation(filesToUpload, context, setUploadContentTaskStatus) {
  const { customerId, assetType, classroomId } = context;
  const assetsMetaData = filesToUpload.map(file => {
    return {
      fileName: removeDiacritics(file.name || file.fileName),
      customerId,
      assetType,
      classroomId
    };
  });

  const uploadAssetPromises = uploadMultipleAssets(filesToUpload, assetsMetaData, setUploadContentStatus);
  return Promise.all(uploadAssetPromises).then(fileUploaded => {
    const status = { isUploading: false };
    setUploadContentTaskStatus(status);
    return fileUploaded.map(file => file.uuid);
  });
}

export function getDueDateTextStyle(dueDate) {
  let dueDateTextStyle;
  let daysLeft = dayjs(dueDate).diff(dayjs(), 'days');
  if (daysLeft > 1) {
    dueDateTextStyle = { color: '#0caae3' };
  }
  if (daysLeft <= 1 && daysLeft >= 0) {
    dueDateTextStyle = { color: '#f05060' };
  }

  return dueDateTextStyle;
}
